const RecipientBlock = ({ lines = [] }) => (
  <table className="pdf-table-py-2">
    <tbody>
      {lines.map((line, idx) => (
        <tr key={idx}>
          <td>{line}</td>
        </tr>
      ))}
    </tbody>
  </table>
)

export default RecipientBlock
